import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';

const initialState = {
    loading: false,
    totalFiles: 0,
    totalPages: 1,
    page: 1,
    list: []
};

// ==============================|| SLICE - Files ||============================== //

const filesSlice = createSlice({
    name: 'files',
    initialState,
    reducers: {
        loadingSetter(state, action) {
            state.loading = action.payload
        },
        filesSetter(state, action) {
            const { list, page, totalFiles, totalPages } = action.payload;
            state.totalFiles = totalFiles
            state.totalPages = totalPages
            state.page = page
            state.list = list
        },
        textToNumberSetter(state, action) {
            const { id, useTextToNumber } = action.payload;
            const fileIndex = state.list.findIndex(f => f.id == id);
            let tempFiles = state.list;
            tempFiles[fileIndex].useTextToNumber = useTextToNumber
        },
        punctuationsSetter(state, action) {
            const { id, usePunctuations } = action.payload;
            const fileIndex = state.list.findIndex(f => f.id == id);
            let tempFiles = state.list;
            tempFiles[fileIndex].usePunctuations = usePunctuations
        },
        fileUpdater(state, action) {
            const { id, percent, remaining, status, startDate, finishDate, resultUrl } = action.payload;
            const fileIndex = state.list.findIndex(f => f.id == id);
            let tempFiles = state.list;
            if (fileIndex != -1) {
                if (percent) {
                    tempFiles[fileIndex].percent = percent
                }
                if (remaining) {
                    tempFiles[fileIndex].remaining = remaining
                }
                if (status) {
                    tempFiles[fileIndex].status = status
                }
                if (startDate) {
                    tempFiles[fileIndex].startDate = startDate
                }
                if (finishDate) {
                    tempFiles[fileIndex].finishDate = finishDate
                }
                if (resultUrl) {
                    tempFiles[fileIndex].resultUrl = resultUrl
                }
                state.list = tempFiles
            }
        }
    }
});

const { loadingSetter, filesSetter, textToNumberSetter, punctuationsSetter, fileUpdater } = filesSlice.actions;

const getFiles = (params) => async dispatch => {
    try {
        dispatch(loadingSetter(true));
        const response = await axios.get("/api/files/get", { params })
        dispatch(filesSetter(response.data));
        dispatch(loadingSetter(false));
    } catch (error) {
        dispatch(loadingSetter(false));
        console.log(error);
    }

}

const removeFile = (id) => async dispatch => {
    try {
        dispatch(loadingSetter(true));
        await axios.delete("/api/files/remove", { params: { id } })
        dispatch(loadingSetter(false));
    } catch (error) {
        dispatch(loadingSetter(false));
        console.log(error);
    }

}

const setTextToNumber = (id, useTextToNumber) => async dispatch => {
    try {
        dispatch(loadingSetter(true));
        await axios.put("/api/files/set-text-to-number", { id, useTextToNumber })
        dispatch(textToNumberSetter({ id, useTextToNumber }));
        dispatch(loadingSetter(false));
    } catch (error) {
        dispatch(loadingSetter(false));
        console.log(error);
    }

}

const setPunctuations = (id, usePunctuations) => async dispatch => {
    try {
        dispatch(loadingSetter(true));
        await axios.put("/api/files/set-punctuations", { id, usePunctuations })
        dispatch(punctuationsSetter({ id, usePunctuations }));
        dispatch(loadingSetter(false));
    } catch (error) {
        dispatch(loadingSetter(false));
        console.log(error);
    }

}

export {
    getFiles,
    removeFile,
    setPunctuations,
    setTextToNumber,
    fileUpdater
}

export default filesSlice.reducer;
